// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2Pbgy","title":"Info_title__2CItI","selects":"Info_selects__2GimG","requiredAsterisk":"Info_requiredAsterisk__12SER"};